import React from 'react'
import Dropzone from 'react-dropzone'
import cn from 'classnames'
import BaseIcon from 'react-icon-base'
import { withTranslation } from 'react-i18next'

import Camera from 'app/components/SVGS/Camera'
import './styles.scss'

const bc = 'add-photo-instead-user-avatar'

const UserAvatarPhotoUploader = ({ t, i18n: { language }, onDrop }) => (
  <Dropzone className={`${bc}__bg`} onDrop={onDrop}>
    <Camera className={cn(`${bc}__image`, `${bc}__animate-frontside`)} size={30} />
    <BaseIcon viewBox="0 0 50 50" width="30" height="30" className={`${bc}__animate-backside`}>
      <text x="21" y="18" className={`${bc}__text__${language}`} textAnchor="middle">
        {t('Add')}
      </text>
      <text x="21" y="26" className={`${bc}__text__${language}`} textAnchor="middle">
        {t('Picture')}
      </text>
    </BaseIcon>
  </Dropzone>
)

export default withTranslation('user')(UserAvatarPhotoUploader)
